/* tslint:disable */

import {Injectable} from '@angular/core';
import {ImageDrawingInfo, TwoDView} from "./twoDViewModels";

declare var jQuery: any;

declare function loadImage(imgSRC, imgDrawingProperties, imgs, imgIndex): any;

declare function createMergedImage(loaders, images): any;

declare function drawImageOnCanvas(imageData, canvas): any;

declare function mergeImageWithImagesDrawingInfo(referenceImageData, loaders, loadedImagesData): any;

declare function mergeImageDataWithImagesDrawingInfo(referenceImageData, imagesData): any;

declare function mergeImagesData(imgsData): any;

@Injectable({
    providedIn: 'root'
})
export class TwoDDrawingService {

    constructor() {
    }

    loadImages(imagesDrawingInfo: ImageDrawingInfo[], activeView: TwoDView, layer: number, loadedImages) {
        let imagesCount = imagesDrawingInfo.length;
        let loaders = Array(imagesCount).fill(null);
        // let loadedImages = Array(imagesCount).fill(null);

        for (let i = 0; i < imagesCount; i++) {
            let currentImageInfo = imagesDrawingInfo[i];
            if (currentImageInfo) {
                let imagesDirectory = currentImageInfo.getActiveDirectory(activeView);
                let imgPath = ImageDrawingInfo.getImgSRC(imagesDirectory, layer);

                loaders[i] = loadImage(imgPath, currentImageInfo, loadedImages, i);
            }

        }
        return loaders;
    }

    mergeImages__old(imagesDrawingInfo: ImageDrawingInfo[], activeView: TwoDView, layer: number) {
        let imagesCount = imagesDrawingInfo.length;
        let loaders = Array(imagesCount).fill(null);
        let loadedImages = Array(imagesCount).fill(null);

        for (let i = 0; i < imagesDrawingInfo.length; i++) {
            let currentImageInfo = imagesDrawingInfo[i];

            let imagesDirectory = currentImageInfo.getActiveDirectory(activeView);

            let imgPath = ImageDrawingInfo.getImgSRC(imagesDirectory, layer);

            loaders[i] = loadImage(imgPath, currentImageInfo, loadedImages, i);
        }

        return new Promise(resolve => {
            createMergedImage(loaders, loadedImages).then(mergedImage => {
                resolve(mergedImage);
            });
        });
    }

    mergeImages(loaders, loadedImages) {
        return new Promise(resolve => {
            createMergedImage(loaders, loadedImages).then(mergedImage => {
                resolve(mergedImage);
            });
        });
    }

    mergeImageData(imgsData) {
        return mergeImagesData(imgsData);
    }

    mergeOneImageWithEachImageFromArray(referenceImageData, loaders, loadedImages) {
        return new Promise(resolve => {
            mergeImageWithImagesDrawingInfo(referenceImageData, loaders, loadedImages).then(mergedImage => {
                resolve(mergedImage);
            });
        });
    }

    mergeOneImagesDataWithEachImageFromArray(referenceImageData, imagesData) {
        return mergeImageDataWithImagesDrawingInfo(referenceImageData, imagesData);
    }

    drawImage(image, canvas) {
        drawImageOnCanvas(image, canvas);
    }


}
